import { on, fire } from "delegated-events";
import scrollTo from "@common/scroll-to";

const handleScroll = (event, el) => {
  let targetSelector = null;

  if (el.dataset.scroll) {
    targetSelector = el.dataset.scroll;
  } else if (el.tagName === "A") {
    targetSelector = el.hash;
  } else {
    return;
  }

  if (targetSelector) {
    const target = document.querySelector(targetSelector);
    let offset = 0;

    if (target) {
      event.preventDefault();

      // Deactivate navigation menu if active
      document.documentElement.classList.remove("js-menu-active");

      scrollTo(target, offset);
    }
  }
};

const handleUrl = () => {
  if (window.location.hash) {
    let targetSelector = window.location.hash;

    let target = document.querySelector(targetSelector);

    if (target) {
      document.documentElement.classList.add("is-scrolling");
      window.scrollTo(0, 0);

      scrollTo(target);
    }
  }

  const urlParams = new URLSearchParams(window.location.search);
  const section = urlParams.get("section");

  if (section) {
    const target = document.querySelector(`#${section}`);

    if (target) {
      document.documentElement.classList.add("is-scrolling");

      setTimeout(() => {
        scrollTo(target);
      }, 125);
    }
  }
};

// Automatically scrolls to the first element with the [data-scrolltome] attribute
const handleScrollToMe = () => {
  const target = document.querySelector("[data-scrolltome]");

  if (target) {
    setTimeout(() => {
      scrollTo(target);
    }, 250);
  }
};

export default {
  init: () => {
    on("click", "[data-scroll]", (event) => {
      const el = event.target.closest("[data-scroll]");

      handleScroll(event, el);
    });

    // Handle any custom anchor tags
    on(
      "click",
      '.site-header a[href*="#"]:not(.ignore-scroll), .site-footer a[href*="#"]:not(.ignore-scroll), .wysiwyg a[href*="#"]:not(.ignore-scroll):not([data-scroll]), .btn[href*="#"]:not(.ignore-scroll):not([data-scroll])',
      (event) => {
        const el = event.target.closest("a");

        if (el.dataset.modal !== undefined) {
          return;
        }

        handleScroll(event, el);

        fire(document.documentElement, "scrollto:click");
      },
    );

    handleUrl();
    handleScrollToMe();
  },
};
